export const strings = {
  en: {
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: () =>
      `At no extra cost, 1% of every order will be donated to a nonprofit you choose. Add to cart to choose. Powered by Beam`,
    inlineSeparator: () => `:`,
  },
  fr: {
    ctaTitle: () => `Choisissez votre impact`,
    ctaMessage: () =>
      `Sans frais supplémentaires, 1 % de chaque commande est reversé à l'association de votre choix. Ajoutez au panier pour choisir. Propulsé par Beam.`,
    inlineSeparator: () => `:`,
  },
  es: {
    ctaTitle: () => `Elige tu impacto`,
    ctaMessage: () =>
      `Sin coste adicional, el 1 % de cada pedido se dona a la organización sin ánimo de lucro que elijas. Añádelo al carrito para elegir. Impulsado por Beam.`,
    inlineSeparator: () => `:`,
  },
  de: {
    ctaTitle: () => `Wählen Sie Ihren Impact`,
    ctaMessage: () =>
      `Ohne zusätzliche Kosten wird 1 % jeder Bestellung an eine von Ihnen gewählte gemeinnützige Organisation gespendet. Zum Warenkorb hinzufügen, um auszuwählen. Unterstützt von Beam.`,
    inlineSeparator: () => `:`,
  },
  it: {
    ctaTitle: () => `Scegli il tuo impatto`,
    ctaMessage: () =>
      `L'1 % di ogni acquisto viene donato, senza alcun costo aggiuntivo, a un'organizzazione no-profit a tua scelta. Aggiungi al carrello per scegliere. Promosso da Beam.`,
    inlineSeparator: () => `:`,
  },
  pl: {
    ctaTitle: () => `Wybierz swój wpływ`,
    ctaMessage: () =>
      `1 % wartości każdego zamówienia przekazywany jest na wybraną przez Ciebie organizację non-profit – bez dodatkowych kosztów. Dodaj do koszyka, aby wybrać. Obsługiwane przez Beam.`,
    inlineSeparator: () => `:`,
  },
  ja: {
    ctaTitle: () => `寄付先をお選びください。`,
    ctaMessage: () =>
      `追加費用なしで、ご注文金額の1%を非営利団体へ寄付できます。ご希望の場合、カートに追加して寄付内容をお選びください。Powered by Beam`,
    inlineSeparator: () => `:`,
  },
};
